import React from 'react';
import MagnifyGlassIcon from '../../../../../../../../svg/icons/magnify-glass.svg';
import style from './searchButton.module.pcss';

interface SearchButtonProps {
  handleOpen: () => void;
}

function SearchButton({ handleOpen }: SearchButtonProps): React.ReactElement {
  return (
    <button className={style['search-btn']} type="button" onClick={handleOpen}>
      <MagnifyGlassIcon className={style['search-btn__icon']} />
    </button>
  );
}

export default SearchButton;
